module.exports = __webpack_public_path__ + "img/bg-banner1.26df106e.jpeg";